import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useTelegram } from '../../context/TelegramContext';
import SettingsSection from './SettingsSection';

const InputGroup = styled.div`
  display: flex;
  width: 100%;
`;

const Input = styled.input`
  flex: 1;
  padding: 10px;
  border: none;
  border-radius: 10px 0 0 10px;
  background: #f0f3f9;
  color: #333;
  box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.05),
              inset -2px -2px 5px rgba(255, 255, 255, 0.5);
  
  &:focus {
    outline: none;
  }
  
  /* For number inputs */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  /* Firefox */
  &[type=number] {
    -moz-appearance: textfield;
  }
`;

const SaveButton = styled.button`
  background: #4a6fa1;
  border: none;
  color: white;
  padding: 10px 16px;
  border-radius: 0 10px 10px 0;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  
  &:hover {
    background: #3b5c8a;
  }
`;

const FormMessage = styled.p`
  margin: 8px 0 0;
  font-size: 14px;
  color: ${props => props.isError ? '#e53e3e' : '#38a169'};
  transition: opacity 0.3s ease;
  opacity: ${props => props.visible ? 1 : 0};
`;

const SalaryDateSection = () => {
  const { t } = useTranslation();
  const { telegramUserId } = useTelegram();
  const [salaryDate, setSalaryDate] = useState('');
  const [message, setMessage] = useState({ text: '', isError: false, visible: false });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchSalaryDate();
  }, [telegramUserId]);

  const fetchSalaryDate = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`https://fftg.farodinprojects.org:3000/get_salary_date?user_id=${telegramUserId}`);
      const data = await response.json();
      
      if (response.ok && data.salary_date) {
        setSalaryDate(data.salary_date);
      }
    } catch (error) {
      console.error('Error fetching salary date:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveSalaryDate = async () => {
    const date = parseInt(salaryDate);
    if (isNaN(date) || date < 1 || date > 31) {
      setMessage({ 
        text: t('salary_error'), 
        isError: true,
        visible: true 
      });
      return;
    }
    
    try {
      const response = await fetch('https://fftg.farodinprojects.org:3000/set_salary_date', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: telegramUserId,
          salary_date: date
        })
      });

      if (response.ok) {
        setMessage({ 
          text: t('salary_success'), 
          isError: false,
          visible: true 
        });
      } else {
        throw new Error(t('salary_error'));
      }
    } catch (error) {
      setMessage({ 
        text: t('salary_error'), 
        isError: true,
        visible: true 
      });
    }
    
    // Скрыть сообщение через 3 секунды
    setTimeout(() => {
      setMessage(prev => ({ ...prev, visible: false }));
    }, 3000);
  };

  return (
    <SettingsSection 
      title={t('salary_date_title')} 
      description={t('salary_date_label')}
    >
      {isLoading ? (
        <p>{t('loading')}</p>
      ) : (
        <>
          <InputGroup>
            <Input
              type="number"
              min="1"
              max="31"
              value={salaryDate}
              onChange={(e) => setSalaryDate(e.target.value)}
              placeholder="1-31"
            />
            <SaveButton onClick={handleSaveSalaryDate}>
              {t('save')}
            </SaveButton>
          </InputGroup>
          <FormMessage 
            isError={message.isError} 
            visible={message.visible}
          >
            {message.text}
          </FormMessage>
        </>
      )}
    </SettingsSection>
  );
};

export default SalaryDateSection;